import { Helmet } from "react-helmet";

import { Box } from "@mui/material";

import SignInCore from "./components/SignInCore";

function SignInPage() {
  return (
    <Box className="grid w-screen transition-all place-items-center">
      <Helmet>
        <html lang="en" />
        <title>AwardTool | Sign in</title>
        <meta name="description" content="Sign in to save thousands of dollars and hours with AwardTool." />
      </Helmet>

      <SignInCore />
    </Box>
  );
}

export default SignInPage;
